<template>
  <div>
    <vue-modal id="profileAllInOneModal"
               classes="vue-modal-container"
               height="auto"
               name="profile-all-in-one-modal"
               scrollable

               width="80%">
      <div class="header">
        <h3>{{ trans.header }}</h3>
        <button class="close-modal"
                @click="$modal.hide('profile-all-in-one-modal')">
          <i class="close icon"/>
        </button>
      </div>
      <div class="content">
        <div class="row">
          <!-- profile -->
          <div class="small-12 columns">
            <div class="row">
              <div class="small-12 columns">
                <h3 class="section-title">{{ trans.myData }}</h3>
              </div>
              <div class="small-12 medium-6 large-3 columns">
                <div class="ui form">
                  <div class="field">
                    <label>{{ trans.fullName }}
                      <input v-model="userName"
                             type="text">
                    </label>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 large-3 columns">
                <div class="ui form">
                  <div class="field">
                    <label>{{ trans.password }}
                      <input v-model="userPwdOne"
                             :placeholder="trans.pwdPlaceholder"
                             type="password">
                    </label>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 large-3 columns">
                <div class="ui form">
                  <div class="field">
                    <label>{{ trans.passwordAgain }}
                      <input v-model="userPwdTwo"
                             :placeholder="trans.pwdAgainPlaceholder"
                             type="password">
                    </label>
                  </div>
                </div>
              </div>
              <div class="small-12 medium-6 large-3 columns">
                <div class="ui form">
                  <div class="field">
                    <label>{{ trans.phoneNumber }}
                      <input :value="user.phone"
                             disabled>
                    </label>
                  </div>
                </div>
              </div>
              <div class="small-12 columns">
                <h5>{{ trans.billingAddress }}</h5>
                <div v-if="fullAddressText"
                     class="margin-bottom-1">{{ fullAddressText }}
                </div>
                <div v-else
                     class="margin-bottom-1">{{ trans.notSpecBillAddress }}
                </div>
              </div>
            </div>
            <div class="row align-right">
              <div class="small-12 medium-12 columns">
                <button class="ui positive button"
                        @click="saveModifications">{{ trans.saveBtnText }}
                </button>
                <button class="ui button"
                        @click="changeEmailAddress">{{ trans.emailChangeBtnText }}
                </button>
                <button class="ui button"
                        @click="openPhoneUpdateModal">{{ trans.changePhoneNumberBtn }}
                </button>
                <button class="ui button"
                        @click="openAddressModal">{{ trans.changeBillingAddressBtn }}
                </button>
              </div>
            </div>
          </div>
          <div class="ui divider"></div>
          <!-- ./profile -->
          <!-- reservation -->
          <div v-if="isUserReservationsLoaded"
               class="small-12 columns">
            <h3 class="section-title">{{ trans.myReservations }}</h3>
            <div v-if="hasReservation">
              <table class="ui celled table">
                <thead>
                <tr>
                  <th>{{ trans.resStatus }}</th>
                  <th>{{ trans.resSubject }}</th>
                  <th>{{ trans.resDate }}</th>
                  <th>{{ trans.resClient }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="reservation in filteredUserReservations">
                  <td>{{ getStatusText(reservation.status) }}</td>
                  <td>{{ reservation.subject.typeName }}: {{ reservation.subject.name }}</td>
                  <td>{{ getFormattedDateForReservation(reservation.time.start, reservation.time.end) }}</td>
                  <td>{{ reservation.client.name }}</td>
                </tr>
                </tbody>
              </table>
              <div v-if="paginationPageCount > 1">
                <div class="ui pagination menu">
                  <a v-for="n in paginationPageCount"
                     :class="{'active': currentPaginationPage === n}"
                     class="item"
                     @click="setPaginationPage(n)">
                    {{ n }}
                  </a>
                </div>
              </div>
            </div>
            <div v-else>
              {{ trans.noReservation }}
            </div>
          </div>
          <div class="ui divider"></div>
          <!-- ./reservation -->
          <!-- passes -->
          <div v-if="!passDisabled"
               class="small-12 columns">
            <h3 class="section-title">
              <span>{{ trans.myPasses }}</span>
              <button class="ui button float-right"
                      @click="openPassBuyModal">{{ trans.passBuyBtnTxt }}
              </button>
            </h3>
            <div class="row">
              <table v-if="passes.length > 0"
                     class="ui celled table">
                <thead>
                <tr>
                  <th>{{ trans.pass }}</th>
                  <th>{{ trans.passOccasions }}</th>
                  <th>{{ trans.passValidity }}</th>
                  <th>{{ trans.passBuyingDate }}</th>
                  <th>{{ trans.passClient }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="pass in filteredPasses">
                  <td>{{ pass.name }}</td>
                  <td>{{ pass.currentOccasion }}/{{ pass.occasion }}</td>
                  <td>{{ getFormattedDate(pass.validUntil) }}</td>
                  <td>{{ getFormattedDate(pass.createdAt) }}</td>
                  <td>{{ pass.clientName }}</td>
                </tr>
                </tbody>
              </table>
              <div v-else>
                {{ trans.noPass }}
              </div>
            </div>
          </div>
          <div class="ui divider"></div>
          <!-- ./passes -->
          <!-- balances -->
          <div class="small-12 columns">
            <h3 class="section-title">{{ trans.myBalances }}</h3>
            <div v-if="filteredBalances.length > 0">
              <table class="ui celled table">
                <thead>
                <tr>
                  <th>{{ trans.balanceClient }}</th>
                  <th>{{ trans.balance }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="balance in filteredBalances">
                  <td>{{ balance.clientName }}</td>
                  <td class="right aligned">{{ balance.amount }} Ft</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              {{ trans.noBalance }}
            </div>
          </div>
          <!-- ./balances -->
        </div>
      </div>
      <div class="actions">
      </div>
    </vue-modal>
    <change-email-modal/>
    <change-phone-number-modal @updatePhoneNumber="updatePhoneNumber"/>
    <change-address-modal/>
  </div>
</template>

<script>
/* eslint-disable */
import notify from '../../notify'
import sha1 from 'js-sha1'
import ChangeEmailModal from './ChangeEmailModal'
import ChangePhoneNumberModal from './ChangePhoneNumberModal'
import ChangeAddressModal from './ChangeAddressModal'
import moment from 'moment'
import {mapState} from 'vuex'

export default {
  props: ['name', 'email', 'phone', 'isGoogleCalendar', 'passes', 'isUserReservationsLoaded'],
  data () {
    return {
      userName: this.name,
      // userEmail: this.email,
      userPhone: this.phone,
      isUserGoogleCalendar: this.isGoogleCalendar,
      userPwdOne: '',
      userPwdTwo: '',
      paginationItemPerPage: 10,
      currentPaginationPage: 1,
      paginationPageCount: 1,
    }
  },
  methods: {
    openPassBuyModal () {
      this.$modal.show('pass-buy-modal')
      this.$modal.hide('profile-all-in-one-modal')
    },
    saveModifications () {
      let userData = {
        userName: this.userName,
        // email: this.userEmail,
        // phone: this.userPhone,
        isGoogleCalendar: this.isUserGoogleCalendar,
        pwd: this.userPwdOne,
      }
      let isUserDataValid = true
      let warningMsg = 'Minden mező kitöltése kötelező'

      /*
      if (!isEmailValid(userData.email)) {
        isUserDataValid = false
      }
      */

      if (userData.userName && userData.userName.length < 1) {
        isUserDataValid = false
      }

      /*
      if (userData.phone && userData.phone.length < 1) {
        isUserDataValid = false
      }
      */

      if (userData.pwd.length < 1) {
        userData.pwd = null
      } else if (userData.pwd.length >= 6) {
        if (this.userPwdOne !== this.userPwdTwo) {
          isUserDataValid = false
          warningMsg = 'A jelszavak nem egyeznek'
        } else {
          userData.pwd = sha1(userData.pwd)
        }
      } else {
        isUserDataValid = false
        warningMsg = 'A jelszónak minimum 6 karakterből kell állnia'
      }

      if (isUserDataValid) {
        this.$emit('saveUserModifications', userData)
      } else {
        notify.warning(warningMsg)
      }

      function isEmailValid (email) {
        // eslint-disable-next-line
        let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regExp.test(email)
      }

    },
    updatePhoneNumber (newPhoneNumber) {
      this.$emit('updatePhoneNumber', newPhoneNumber)
    },
    changeEmailAddress () {
      /* eslint-disable */
      this.$modal.show('change-email-modal')
      this.$modal.hide('profile-all-in-one-modal')
    },
    openPhoneUpdateModal () {
      /* eslint-disable */
      this.$modal.show('change-phone-number-modal')
      this.$modal.hide('profile-all-in-one-modal')
    },
    openAddressModal () {
      /* eslint-disable */
      this.$modal.show('change-address-modal')
      this.$modal.hide('profile-all-in-one-modal')
    },
    getFormattedDate (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    getFormattedDateForReservation (start, end) {
      return '' + moment(start).format('YYYY-MM-DD H:mm') + ' - ' + moment(end).format('H:mm')
    },
    getStatusText (status) {
      let statusTranslatle = {
        reserved: 'Lefoglalt',
        missed: 'Mulasztott',
        attended: 'Megjelent',
      }
      if (statusTranslatle.hasOwnProperty(status.toLowerCase())) {
        return statusTranslatle[status]
      }
      return status
    },
    setPaginationPage (newPageNumber) {
      this.currentPaginationPage = newPageNumber
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.profileAllInOneModal,
      passDisabled: state => state.passDisabled,
    }),
    hasReservation () {
      return this.userReservations.length > 0
    },
    userReservations () {
      const itemPerPage = this.paginationItemPerPage
      let result = this.$store.state.userReservations
      this.paginationPageCount = Math.ceil(result.length / itemPerPage)
      return result
    },
    filteredUserReservations () {
      /* eslint-disable */
      const itemPerPage = this.paginationItemPerPage
      let userReservations = this.userReservations
      let currentPaginationPage = this.currentPaginationPage
      let isGlobalMode = this.$store.state.isGlobalMode
      let ownerDomain = this.$store.state.ownerDomain

      let result = []
      result = userReservations.slice((currentPaginationPage - 1) * itemPerPage, currentPaginationPage * itemPerPage)

      if (!isGlobalMode && ownerDomain) {
        result = result.filter(item => item?.client?.domain === ownerDomain)
      }

      return result
    },
    filteredPasses () {
      let isGlobalMode = this.$store.state.isGlobalMode
      let ownerDomain = this.$store.state.ownerDomain
      let passes = [...this.passes]
      if (!isGlobalMode && ownerDomain)
        passes = passes.filter(item => item?.domain === ownerDomain)

      return passes
    },
    filteredBalances () {
      let balances = this.$store.state.balances
      let result = []
      let isGlobalMode = this.$store.state.isGlobalMode
      let ownerDomain = this.$store.state.ownerDomain
      for (let balance of balances) {
        if (isGlobalMode && balance.client !== 'foglaljpalyat.hu')
          result.push(balance)
        else if (!isGlobalMode && balance.client === ownerDomain)
          result.push(balance)
      }
      return result
    },
    user () {
      return this.$store.state.user
    },
    fullAddressText () {
      if (this.user?.countryCode && this.user?.zipCode && this.user?.city && this.user?.address) {
        return `${this.user.countryCode}, ${this.user.zipCode} ${this.user.city} ${this.user.address}`
      }
      return false
    },
  },
  components: {
    ChangeEmailModal,
    ChangePhoneNumberModal,
    ChangeAddressModal,
  },
}
</script>

<style scoped>
.section-title {
  margin-bottom: 1rem;
}

.divider {
  width: 100%;
}

.ui.pagination.menu {
  max-width: 100%;
  overflow-x: scroll;
}

.button {
  float: right;
}
</style>
